import React from "react";
import { Box, Button } from "@material-ui/core";
import MainButton from "../../../../../shared/components/MainButton";
import Text from "../../../../../shared/components/Text";

const retryButtonStyle = {
  width: "100%",
  marginTop: "24px",
  marginBottom: "-8px",
  height: 48,
};

const RetryButton = ({ onClick, hasSelectedPicture, disabled }) => {
  if (!hasSelectedPicture) {
    return <Box style={retryButtonStyle} />;
  }
  return (
    <Button
      className="progression"
      style={retryButtonStyle}
      variant="outlined"
      color="primary"
      onClick={onClick}
      disabled={disabled}
    >
      <Text tId="RETRY" />
    </Button>
  );
};

const SessionExpiredButtons = ({ onRestartProcess }) => {
  return (
    <MainButton onClick={onRestartProcess}>
      <Text tId="RESTART_PROCESS" />
    </MainButton>
  );
};

const UploadModeButtons = ({
  hasSelectedPicture,
  onUploadRetry,
  onContinue,
  continueDisabled,
  isLoading,
}) => {
  return (
    <Box display="flex" flexDirection="column">
      <RetryButton
        onClick={onUploadRetry}
        hasSelectedPicture={hasSelectedPicture}
        disabled={isLoading}
      />
      <MainButton onClick={onContinue} disabled={isLoading || continueDisabled}>
        <Text tId="UPLOAD_PICTURES" />
      </MainButton>
    </Box>
  );
};

const TakePictureButton = ({ onTakePicture, videoReady, documentSide }) => {
  return (
    <MainButton onClick={onTakePicture} disabled={!videoReady}>
      <Text tId="TAKE_PICTURE" /> <Text tId={documentSide} />
    </MainButton>
  );
};

const CaptureModeUploadButtons = ({
  onCameraRetry,
  onContinue,
  continueDisabled,
  isLoading,
}) => {
  return (
    <Box display="flex" flexDirection="column">
      <RetryButton
        onClick={onCameraRetry}
        hasSelectedPicture={true}
        disabled={isLoading}
      />
      <MainButton onClick={onContinue} disabled={isLoading || continueDisabled}>
        <Text tId="UPLOAD_PICTURE" />
      </MainButton>
    </Box>
  );
};

export const DocumentIdPictureFooter = ({
  processExpiredError,
  isLoading,
  isUploadMode,
  hasSelectedPicture,
  captureVideoReady,
  onRestartProcess,
  onTakePicture,
  onUploadRetry,
  onCameraRetry,
  onContinueWithPhoto,
  continueDisabled,
  documentSide,
}) => {
  if (processExpiredError) {
    return <SessionExpiredButtons onRestartProcess={onRestartProcess} />;
  }

  if (isUploadMode) {
    return (
      <UploadModeButtons
        hasSelectedPicture={hasSelectedPicture}
        onUploadRetry={onUploadRetry}
        onContinue={onContinueWithPhoto}
        continueDisabled={continueDisabled}
        isLoading={isLoading}
      />
    );
  }

  if (!hasSelectedPicture && !isLoading) {
    return (
      <TakePictureButton
        onTakePicture={onTakePicture}
        videoReady={captureVideoReady}
        documentSide={documentSide}
      />
    );
  }

  return (
    <CaptureModeUploadButtons
      onCameraRetry={onCameraRetry}
      onContinue={onContinueWithPhoto}
      continueDisabled={continueDisabled}
      isLoading={isLoading}
    />
  );
};
